<template>
    <div class="row row-xs">

        <div class="col-lg-12 col-xl-12 mg-t-10">
            <div class="card mg-b-10">
                <div class="card-header pd-t-20 d-sm-flex align-items-start justify-content-between bd-b-0 pd-b-0">
                    <div>
                        <h6 class="mg-b-5">Summary</h6>
                        <p class="tx-13 tx-color-03 mg-b-0">Fund Transfer Batch Summary By Bank</p>
                    </div>
                    <div class="d-flex mg-t-20 mg-sm-t-0">
                        <div class="btn-group flex-fill">
                            <button class="btn btn-white btn-xs active">Range</button>
                            <button class="btn btn-white btn-xs">Period</button>
                        </div>
                    </div>
                </div><!-- card-header -->
                <div class="card-body pd-y-30">
                    <div class="d-sm-flex">
                        <div class="media">
                            <div class="wd-40 wd-md-50 ht-40 ht-md-50 bg-teal tx-white mg-r-10 mg-md-r-10 d-flex align-items-center justify-content-center rounded op-6">
                            <bar-chart2-icon></bar-chart2-icon>
                            </div>
                            <div class="media-body">
                                <h6 class="tx-sans tx-uppercase tx-10 tx-spacing-1 tx-color-03 tx-semibold tx-nowrap mg-b-5 mg-md-b-8">Total Count</h6>
                                <h4 class="tx-20 tx-sm-18 tx-md-20 tx-normal tx-rubik mg-b-0">{{ft.batchDetails.transcount}}</h4>
                            </div>
                        </div>
                        <div class="media mg-t-20 mg-sm-t-0 mg-sm-l-15 mg-md-l-40">
                            <div class="wd-40 wd-md-50 ht-40 ht-md-50 bg-primary tx-white mg-r-10 mg-md-r-10 d-flex align-items-center justify-content-center rounded op-4">
                                <bar-chart2-icon></bar-chart2-icon>
                            </div>
                            <div class="media-body">
                                <h6 class="tx-sans tx-uppercase tx-10 tx-spacing-1 tx-color-03 tx-semibold mg-b-5 mg-md-b-8">Total Successful</h6>
                                <h4 class="tx-20 tx-sm-18 tx-md-20 tx-normal tx-rubik mg-b-0">{{ft.batchDetails.totalsuccess}}</h4>
                            </div>
                        </div>
                        <div class="media mg-t-20 mg-sm-t-0 mg-sm-l-15 mg-md-l-40">
                            <div class="wd-40 wd-md-50 ht-40 ht-md-50 bg-pink tx-white mg-r-10 mg-md-r-10 d-flex align-items-center justify-content-center rounded op-5">
                                <bar-chart2-icon></bar-chart2-icon>
                            </div>
                            <div class="media-body">
                                <h6 class="tx-sans tx-uppercase tx-10 tx-spacing-1 tx-color-03 tx-semibold mg-b-5 mg-md-b-8">Total Amount</h6>
                                <h4 class="tx-20 tx-sm-18 tx-md-20 tx-normal tx-rubik mg-b-0">{{ft.batchDetails.totalamount | toCurrency}}</h4>
                            </div>
                        </div>
                    </div>
                </div><!-- card-body -->
<!--                <div class="table-responsive">-->
<!--                    <table class="table table-dashboard mg-b-0">-->
<!--                        <thead>-->
<!--                        <tr>-->
<!--                            <th class="text-left">BankCode</th>-->
<!--                            <th class="text-left">BankName</th>-->
<!--                            <th class="text-left">TotalCount</th>-->
<!--                            <th class="text-left">TotalAmount</th>-->
<!--                        </tr>-->
<!--                        </thead>-->
<!--                        <tbody>-->
<!--                            <tr v-for="(tran, index)  in ft.tranSummary" v-bind:key="index">-->
<!--                                <td class="tx-color-03 tx-normal">{{tran.bankcode}}</td>-->
<!--                                <td class="tx-medium text-left">{{tran.bankname}}</td>-->
<!--                                <td class="text-left tx-teal">{{tran.totalcount}}</td>-->
<!--                                <td class="text-left tx-teal">{{tran.totalamount}}</td>-->
<!--                            </tr>-->
<!--                        </tbody>-->
<!--                    </table>-->
<!--                </div>&lt;!&ndash; table-responsive &ndash;&gt;-->
            </div><!-- card -->


        </div><!-- col -->
    </div>
</template>

<script>
    import { BarChart2Icon } from 'vue-feather-icons'
    import {mapState} from 'vuex'
    export default {
        name: "Revenue",
        components:{
            BarChart2Icon
        },
        data:()=>{
            return{
                revenueData: {
                    labels: ['VueJs', 'EmberJs', 'ReactJs', 'AngularJs'],
                    datasets: [
                        {
                            backgroundColor: [
                                '#41B883',
                                '#E46651',
                                '#00D8FF',
                                '#DD1B16'
                            ],
                            data: [40, 20, 80, 10]
                        }
                    ]
                },
                revenueOptions: {
                    responsive: true,
                    maintainAspectRatio: false
                },

            }
        },
        computed:{
            ...mapState([
                'ft'
            ]),
        }
    }
</script>

<style scoped>

</style>
